import axios from "axios";
import Vue from "vue";
import App from "./app/App.vue";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import router from "./router/index";
import { sync } from "vuex-router-sync";
import store from "./store/index";
import interceptor from "./interceptor";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

Vue.component("VueSlider", VueSlider);

Vue.config.productionTip = false;
sync(store, router); /// sync vuex/router. Returns an unsync callback fn

const axiosInstance = axios.create();
const token = sessionStorage.getItem("token");

if (token) {
  axios.defaults.headers.common["Authorization"] = `JWT ${token}`;
}

interceptor(axiosInstance);
Vue.prototype.$axios = axiosInstance;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
